<template>
  <FilterSelectorItem
    v-if="tShirtSizeOptions.length > 0"
    :label="filterLabel"
    :options="tShirtSizeOptions"
    :variant="variant">
    <template #default="props">
      <ul class="max-h-80 overflow-y-auto" data-testid="menu-option-list">
        <UiListItem
          v-for="(option, index) in tShirtSizeOptions"
          :key="option.value"
          class="hover:bg-neutral-whisper focus:bg-neutral-faint"
          :is-checked="option.selected"
          :checkbox-appearance="props.checkboxAppearance"
          :list-variant="props.listVariant"
          :check-box-menu="true"
          :class="{
            'border-t': option.hasDividerAbove,
          }"
          :data-testid="`menu-option-button-${index}`"
          @list-item-click="handleFilterChange(option.value)">
          <UiTShirtSizeIcon :name="option.icon" size="sm" />
          {{ option.label }}
        </UiListItem>
      </ul>
    </template>
  </FilterSelectorItem>
</template>

<script setup lang="ts">
import UiListItem from "@dpa-id-components/dpa-shared-components/src/components/UiListItem/UiListItem.vue";
import UiTShirtSizeIcon from "@dpa-id-components/dpa-shared-components/src/components/UiTShirtSizeIcon/UiTShirtSizeIcon.vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";

import useFilterItem from "@/composition/archive/useFilterItem.ts";
import useFilterSelectorStore from "@/stores/search/filterSelector.ts";
import { tShirtSizeIconMap } from "@/utils/content.ts";

import FilterSelectorItem from "./FilterSelectorItem.vue";
import type { FilterSelectorItemWrapperProps } from "./filterSelectorItemWrapper";

defineProps<FilterSelectorItemWrapperProps>();

const filterSelectorStore = useFilterSelectorStore();
const { tShirtSizeFilter, selectedTShirtSizes } =
  storeToRefs(filterSelectorStore);
const { handleFilterChange, filterLabel } = useFilterItem(
  tShirtSizeFilter,
  selectedTShirtSizes,
);

const tShirtSizeOptions = computed(() =>
  tShirtSizeFilter.value.options.flatMap((option) => {
    const icon = tShirtSizeIconMap.get(option.value);
    return icon ? [{ ...option, icon }] : [];
  }),
);
</script>
